<template>
  <el-dialog
      title="Thiết lập nhận xét"
      :visible.sync="dialogVisible"
      width="1300px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="2vh"
  >
    <div v-if="systemConfigSchoolData != null" v-loading="loading" class="wrapper-table">
      <el-table
          :data="configRows"
          border
          class="sk-table custom-attendance-table"
          style="width: 100%"
          :max-height="$tableMaxHeight"
          :loading="loading"
      >
        <el-table-column type="index" label="STT" width="55" align="center"/>
        <el-table-column label="Nội dung thiết lập" min-width="500">
          <template v-slot="{row}">
            <div class="wrapper-config-label">
              <span class="config-desc">{{ row.description }}</span>
              <el-tooltip v-if="row.tooltip != null"
                          :content="row.tooltip"
                          placement="top"
                          :open-delay="300"
                          effect="dark"
                          popper-class="config-tooltip-popper"
              >
                <i class="el-icon-question" style="color: #6a96d6;"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Thiết lập" width="380" align="center">
          <template v-slot="{row}">
            <!-- BOOLEAN -->
            <template v-if="row.type === 'boolean'">
              <el-radio-group v-model="getObj(row)[row.field]" :disabled="row.disabled">
                <el-radio :label="!row.invertLabel">{{ row.labelTrue || 'Có' }}</el-radio>
                <el-radio :label="!!row.invertLabel">{{ row.labelFalse || 'Không' }}</el-radio>
              </el-radio-group>
            </template>
            <!-- TIME -->
            <template v-else-if="row.type === 'time'">
              <el-time-picker style="width:280px" size="mini" :clearable="false"
                              value-format="HH:mm" format="HH:mm"
                              v-model="getObj(row)[row.field]" :disabled="row.disabled"
                              :picker-options="{selectableRange:'00:00:00 - 23:59:59'}" placeholder="Chọn"/>
            </template>
            <!-- INPUT -->
            <template v-else-if="row.type === 'input'">
              <el-input size="mini" style="width:280px" v-model="getObj(row)[row.field]"
                        :disabled="row.disabled" :placeholder="row.placeholder||'Nhập'" :maxlength="row.maxlength"/>
            </template>
            <!-- NUMBER -->
            <template v-else-if="row.type === 'number'">
              <el-input-number size="mini" v-model="getObj(row)[row.field]"
                               :disabled="row.computedDisabled ? row.computedDisabled(systemConfigSchoolData) : row.disabled"
                               :min="row.min" :max="row.max" :step="row.step||1"/>
              <span v-if="row.suffix" style="margin-left:10px">{{ row.suffix }}</span>
            </template>
            <!-- SELECT -->
            <template v-else-if="row.type === 'select'">
              <el-select v-model="getObj(row)[row.field]" :disabled="row.disabled"
                         :placeholder="row.placeholder||'Chọn'" style="width:250px">
                <el-option v-for="opt in row.options" :key="opt.value" :value="opt.value" :label="opt.label"/>
              </el-select>
            </template>
            <!-- CHECKBOX GROUP -->
            <template v-else-if="row.type === 'checkbox-group'">
              <el-checkbox v-for="cb in row.checkboxes" :key="cb.field"
                           v-model="getObj(row)[cb.field]" :disabled="row.disabled">{{ cb.label }}
              </el-checkbox>
            </template>
            <!-- SWITCH GROUP -->
            <template v-else-if="row.type === 'switch-group'">
              <div class="switch-group">
                <div v-for="(item,idx) in row.switches" :key="idx" class="switch-item">
                  <span>{{ item.label }}</span>
                  <el-switch v-model="getObj(row)[item.field]" :disabled="row.disabled"/>
                </div>
              </div>
            </template>
            <!-- MULTI BOOLEAN -->
            <template v-else-if="row.type === 'multi-boolean'">
              <div v-for="(sub,idx) in row.subFields" :key="idx" class="multi-boolean-row">
                <span class="multi-boolean-label">{{ sub.label }}</span>
                <el-radio-group v-model="getObj(row)[sub.field]" :disabled="row.disabled">
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </div>
            </template>
            <!-- INPUT + TIME COMBO -->
            <template v-else-if="row.type === 'input-time'">
              <div>
                <el-input size="mini" style="width:280px" v-model="getObj(row)[row.field]"
                          :placeholder="row.placeholder||'Nhập số ngày'"/>
              </div>
              <div style="margin-top:10px">
                <el-time-picker style="width:280px" size="mini" :clearable="false"
                                value-format="HH:mm" format="HH:mm" v-model="getObj(row)[row.timeField]"
                                :picker-options="{selectableRange:'00:00:00 - 23:59:59'}" placeholder="Chọn"/>
              </div>
            </template>
            <!-- LATE PICKUP -->
            <template v-else-if="row.type === 'late-pickup'">
              <div class="composite-config">
                <el-radio-group v-model="schoolConfig.statusBlock">
                  <el-radio :label="true">Block</el-radio>
                  <el-radio :label="false">Ngày</el-radio>
                </el-radio-group>
                <div style="margin-top:10px">
                  <span>Số phút: </span>
                  <el-input-number v-model="schoolConfig.blockLeaveKid" style="width:160px" :min="0" :step="1"
                                   size="mini"/>
                </div>
                <el-radio-group v-model="schoolConfig.statusUpDown" style="margin-top:10px">
                  <el-radio :label="true">Làm tròn lên</el-radio>
                  <el-radio :label="false">Làm tròn xuống</el-radio>
                </el-radio-group>
              </div>
            </template>
            <!-- HOME TAB ORDER -->
            <template v-else-if="row.type === 'home-tab-order'">
              <div class="home-tab-config">
                <table class="tab-order-table">
                  <tr>
                    <td v-for="tab in homeTabItems" :key="tab.field">{{ tab.label }}</td>
                  </tr>
                  <tr>
                    <td v-for="tab in homeTabItems" :key="'cb-'+tab.field">
                      <el-checkbox v-model="schoolConfig[tab.activeField]"
                                   :disabled="tab.activeField==='activeShowNews'"
                                   @change="(v)=>handleTabActiveChange(tab,v)"/>
                    </td>
                  </tr>
                  <tr>
                    <td v-for="tab in homeTabItems" :key="'sel-'+tab.field">
                      <el-select size="mini" style="width:55px" v-model="schoolConfig[tab.sttField]"
                                 :disabled="!schoolConfig[tab.activeField]"
                                 @change="(v)=>handleTabOrderChange(tab,v)">
                        <el-option v-for="n in activeTabCount" :key="n" :value="n" :label="String(n)"/>
                      </el-select>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
            <!-- TUITION PLUS -->
            <template v-else-if="row.type === 'tuition-plus'">
              <div class="composite-config">
                <div>Gửi thông báo hoá đơn mới?
                  <el-radio-group v-model="schoolConfig.statusOrderNew" style="margin-left:8px">
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:8px">
                  Ngày bắt đầu:
                  <el-input-number size="small" v-model="schoolConfig.dateSendPlus" style="width:100px"/>
                  <span v-if="schoolConfig.sendRepeatPlus&&!schoolConfig.statusOrderNew" style="margin-left:10px">
                    Bước nhảy: <el-input-number size="small" v-model="schoolConfig.dateJumpPlus" style="width:100px"/>
                  </span>
                </div>
                <div v-if="!schoolConfig.statusOrderNew" style="margin-top:8px">Gửi lặp lại?
                  <el-radio-group v-model="schoolConfig.sendRepeatPlus" style="margin-left:8px">
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top:8px">
                  Hết hạn trước:
                  <el-input-number size="small" v-model="schoolConfig.datePlus" style="width:100px"/>
                  Ngày
                </div>
              </div>
            </template>
            <!-- TUITION PARENT -->
            <template v-else-if="row.type === 'tuition-parent'">
              <div class="composite-config">
                <div>Ngày bắt đầu:
                  <el-input-number size="small" v-model="schoolConfig.dateSendParent" style="width:100px"/>
                </div>
                <div style="margin-top:8px">
                  Bước nhảy:
                  <el-input-number size="small" v-model="schoolConfig.dateJumpParent" style="width:100px"/>
                  <span style="margin-left:10px">Tần suất: <el-input-number size="small"
                                                                            v-model="schoolConfig.dateFrequencyParent"
                                                                            style="width:100px"/></span>
                </div>
                <div style="margin-top:8px">
                  Hết hạn trước:
                  <el-input-number size="small" v-model="schoolConfig.dateParent" style="width:100px"/>
                  Ngày
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else-if="!loading" style="text-align:center;padding:40px 0;color:#909399">Không có dữ liệu</div>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" size="medium" @click="closeDialog">
        <i class="el-icon-circle-close"/><span>Đóng</span>
      </el-button>
      <el-button type="success" size="medium" :loading="loadingButton" @click="submitForm">
        <i class="el-icon-circle-check"/><span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import AbsentLetterConfigService from "@/absent_letter_v3/services/AbsentLetterConfigService";

const HOME_TABS = [
  {label: "Tin tức", field: "news", activeField: "activeShowNews", sttField: "sttShowNews"},
  {label: "Facebook", field: "facebook", activeField: "activeShowFacebook", sttField: "sttShowFacebook"},
  {label: "Video", field: "video", activeField: "activeShowVideo", sttField: "sttShowVideo"},
  {label: "Website trường", field: "website", activeField: "activeShowWebsiteSchool", sttField: "sttShowWebsiteSchool"},
  {label: "Tiktok", field: "tiktok", activeField: "activeShowTiktok", sttField: "sttShowTiktok"},
  {label: "Onekids Page", field: "onekidsPage", activeField: "activeShowOneKidsPage", sttField: "sttShowOneKidsPage"},
];

const SCHEMA = [
  {
    field: "evaluate",
    type: "boolean",
    source: "school",
    description: "Có cần duyệt đánh giá nhận xét hay không?",
  },
  {
    field: "commentsWithoutAttendance",
    type: "boolean",
    source: "school",
    description: "Cho phép nhận xét ngày học sinh không cần điểm danh?",
  },
];

export default {
  name: "EvaluationConfigDialog",
  props: {
    dialogVisible: {type: Boolean, default: false},
  },
  data() {
    return {
      systemConfigSchoolData: null,
      loading: false,
      loadingButton: false,
      homeTabItems: HOME_TABS,
      sttSnapshot: {},
    };
  },
  computed: {
    schoolConfig() {
      return this.systemConfigSchoolData ? this.systemConfigSchoolData.schoolConfigInSysResponse : {};
    },
    sysConfig() {
      return this.systemConfigSchoolData ? this.systemConfigSchoolData.sysConfigResponse : {};
    },
    configRows() {
      return SCHEMA;
    },
    activeTabCount() {
      if (!this.schoolConfig) return 6;
      return HOME_TABS.filter(t => this.schoolConfig[t.activeField]).length;
    },
  },
  methods: {
    getObj(row) {
      return row.source === "sys" ? this.sysConfig : this.schoolConfig;
    },
    getDataInitial() {
      this.loading = true;
      AbsentLetterConfigService.get()
          .then(resp => {
            this.systemConfigSchoolData = resp.data.data;
            this._saveSttSnapshot();
          })
          .catch(err => {
            console.log(err);
            this.systemConfigSchoolData = null;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // ─── HOME TAB GENERIC METHODS ──────────────────────────────────
    handleTabActiveChange(tab, value) {
      const cfg = this.schoolConfig;
      const currentStt = cfg[tab.sttField];
      if (!value) {
        HOME_TABS.forEach(t => {
          if (t.field !== tab.field && cfg[t.sttField] > currentStt) cfg[t.sttField]--;
        });
        cfg[tab.sttField] = HOME_TABS.length;
      } else {
        const activeCount = HOME_TABS.filter(t => t.field !== tab.field && cfg[t.activeField]).length;
        cfg[tab.sttField] = activeCount + 1;
      }
      this._saveSttSnapshot();
    },
    handleTabOrderChange(tab, newVal) {
      const cfg = this.schoolConfig;
      const oldVal = this._sttSnapshot[tab.field];
      HOME_TABS.forEach(t => {
        if (t.field !== tab.field && cfg[t.sttField] === newVal) {
          cfg[t.sttField] = oldVal || 1;
        }
      });
      cfg[tab.sttField] = newVal;
      this._saveSttSnapshot();
    },
    _saveSttSnapshot() {
      this._sttSnapshot = {};
      HOME_TABS.forEach(t => {
        this._sttSnapshot[t.field] = this.schoolConfig[t.sttField];
      });
    },
    _validateTabOrder() {
      const cfg = this.schoolConfig;
      const vals = HOME_TABS.filter(t => cfg[t.activeField]).map(t => cfg[t.sttField]);
      return new Set(vals).size === vals.length;
    },
    // ─── SUBMIT & CLOSE ────────────────────────────────────────────
    submitForm() {
      if (!this._validateTabOrder()) {
        this.$message({
          message: "Không được chọn thứ tự hiển thị tin tức màn Home giống nhau",
          type: "error",
          duration: 2000
        });
        return;
      }
      this.loadingButton = true;
      AbsentLetterConfigService.update(this.systemConfigSchoolData)
          .then(() => {
            this.$message({message: "Cập nhật thành công", type: "success"});
            setTimeout(() => this.closeDialog(), 500);
          })
          .catch(err => {
            this.$message({message: err.response?.data?.message || "Có lỗi xảy ra", type: "error"});
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButton = false;
            }, 500);
          });
    },
    closeDialog() {
      this.$emit("dialog-close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  padding: 18px 24px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 19px !important;
  font-weight: 600;
}

::v-deep .el-dialog__body {
  max-height: 74vh;
  overflow-y: auto;
  background: #f8fafc;
  padding: 20px 24px !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 22px;
}

.custom-attendance-table {
  border-radius: 10px !important;
  overflow: hidden;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 16px rgba(51, 65, 85, 0.04);

  /deep/ th.el-table__cell {
    background-color: #6a96d6 !important;
    color: #fff !important;
    font-weight: 600;
    padding: 8px 0;
    border-right: 1px solid #e2e8f0 !important;
    font-size: 13px;

    &.is-leaf {
      background-color: #6a96d6 !important;
      border-bottom: 1px solid #5a85c2 !important;
    }
  }

  /deep/ tr.el-table__row:hover > td.el-table__cell {
    background-color: #f0f7ff !important;
  }

  /deep/ td.el-table__cell {
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
    border-right: 1px solid #f1f5f9;
  }
}

.wrapper-config-label {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .config-desc {
    text-align: left;
    padding: 0 10px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    display: block;
  }
}

.switch-group {
  padding: 8px;
  text-align: left;

  .switch-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
    font-size: 13px;
  }
}

.multi-boolean-row {
  display: flex;
  align-items: center;
  padding: 4px 0;

  .multi-boolean-label {
    width: 70px;
    text-align: left;
    font-size: 13px;
    color: #606266;
  }
}

.home-tab-config {
  overflow-x: auto;

  .tab-order-table {
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    td {
      padding: 4px 6px;
      text-align: center;
    }
  }
}

.composite-config {
  text-align: left;
  padding: 8px;
  font-size: 13px;
}

/deep/ .config-tooltip-popper {
  max-width: 480px;
  line-height: 1.5;
  white-space: normal;
}

::v-deep .el-dialog__footer {
  background: #f1f5f9;
  padding: 14px 24px !important;
  border-top: 1px solid #e2e8f0;
}

/* Disabled & Readonly form controls (màu xanh nổi bật dễ đọc) */
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-input.is-disabled input,
::v-deep input:disabled,
::v-deep input[disabled],
::v-deep .el-textarea.is-disabled .el-textarea__inner,
::v-deep .el-textarea.is-disabled textarea,
::v-deep textarea:disabled,
::v-deep textarea[disabled],
::v-deep .el-select .el-input.is-disabled .el-input__inner,
::v-deep .el-date-editor.is-disabled,
::v-deep .el-date-editor.is-disabled .el-input__inner,
::v-deep .el-date-editor.is-disabled input,
::v-deep .el-date-editor.is-disabled .el-range-input,
::v-deep .el-input-number.is-disabled .el-input__inner,
::v-deep input[readonly],
::v-deep textarea[readonly],
::v-deep .el-input.is-readonly .el-input__inner {
  color: #1d4ed8 !important;
  -webkit-text-fill-color: #1d4ed8 !important;
  font-weight: 600 !important;
  background-color: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

::v-deep .el-input.is-disabled .el-input__prefix,
::v-deep .el-input.is-disabled .el-input__suffix,
::v-deep .el-input.is-disabled .el-input__icon {
  color: #1d4ed8 !important;
}

::v-deep .el-radio.is-disabled .el-radio__label,
::v-deep .el-radio__input.is-disabled + .el-radio__label,
::v-deep .el-radio__input.is-disabled.is-checked + .el-radio__label,
::v-deep .el-checkbox.is-disabled .el-checkbox__label,
::v-deep .el-checkbox__input.is-disabled + .el-checkbox__label,
::v-deep .el-checkbox__input.is-disabled.is-checked + .el-checkbox__label {
  color: #1d4ed8 !important;
  -webkit-text-fill-color: #1d4ed8 !important;
  font-weight: 600 !important;
}
</style>
